import React from 'react';

export const ComingSoonBanner: React.FC = () => {
  return null;
};
